import { useStorage } from '@surglogs/hook.storage'

export const useLocationToVisitStorage = ({
  storage = window.localStorage,
  key = 'location-to-visit',
}: {
  storage?: Window['sessionStorage'] | Window['localStorage']
  key?: string
} = {}) => useStorage<Location | null>(storage, key, { stringify: true })
